// front/src/constants/roles.js
// Libelles d'affichage des roles : source unique, evite la duplication dans les ecrans To Do.
export const ROLE_LABELS = {
  medecin: 'Médecin',
  infirmiere: 'Infirmière',
  secretaire: 'Secrétaire',
  admin: 'Admin',
};
